import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';

function ModalView({ title, onClose, children }) {
    const dialog = useRef(null);
    const titleId = useId();
    const close = useRef(onClose);
    close.current = onClose;

    useEffect(() => {
        const element = dialog.current;
        const trigger = document.activeElement;
        const previousOverflow = document.body.style.overflow;
        element.showModal();
        document.body.style.overflow = 'hidden';
        const handleCancel = event => {
            event.preventDefault();
            close.current();
        };
        element.addEventListener('cancel', handleCancel);
        return () => {
            element.removeEventListener('cancel', handleCancel);
            element.close();
            document.body.style.overflow = previousOverflow;
            if (trigger && trigger.isConnected) trigger.focus();
        };
    }, []);

    return createPortal(
        <dialog className="project-dialog" ref={dialog} aria-labelledby={titleId} onClick={event => {
            if (event.target !== event.currentTarget) return;
            const rect = event.currentTarget.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) onClose();
        }}>
            <div className="dialog-heading"><h2 id={titleId}>{title}</h2><button className="icon-button" type="button" onClick={onClose} aria-label="Close project">×</button></div>
            {children}
        </dialog>,
        document.getElementById('modal-root')
    );
}

export default ModalView;
